
class PillFactory {
  constructor(template) {
    this.template = template;
  }

  make(label, options = { labelOnly: true, ordinal: null }) {
    const decoder = document.createElement('textarea');
    decoder.innerHTML = this.template.replace(/idx/g, options.ordinal);

    const pillContainer = document.createElement('div');
    pillContainer.innerHTML = decoder.value;

    const pill = pillContainer.firstChild;

    if (options.labelOnly) {
      pill.querySelector('input').remove();
      pill.querySelector('button').classList.remove('d-none');
    } else {
      pill.querySelector('input').value = label;
      pill.querySelector('button').remove();
    }

    pill.querySelector('span[data-role="item"]').innerHTML = label;

    return pill;
  }
}

export { PillFactory };